import { ManagementLevel } from '../../signup-data/ManagementLevelOption';
export let DataStateKey;

(function (DataStateKey) {
  DataStateKey["value"] = "value";
  DataStateKey["prefilled"] = "prefilled";
  DataStateKey["completed"] = "completed";
  DataStateKey["skipped"] = "skipped";
  DataStateKey["validation"] = "validation";
  DataStateKey["errorMessage"] = "errorMessage";
})(DataStateKey || (DataStateKey = {}));

export const SeniorityLevel = {
  [ManagementLevel.Owner]: 'Owner',
  [ManagementLevel.ExecutiveTeam]: 'Executive Team',
  [ManagementLevel.Manager]: 'Manager',
  [ManagementLevel.Employee]: 'Employee',
  [ManagementLevel.Freelancer]: 'Freelancer',
  [ManagementLevel.StudentIntern]: 'Student/Intern',
  [ManagementLevel.Other]: 'Other'
};
export const JobRoleFromManagementLevel = {
  [ManagementLevel.Owner]: 'other',
  [ManagementLevel.ExecutiveTeam]: 'other',
  [ManagementLevel.Manager]: 'other',
  [ManagementLevel.Employee]: 'sales-rep',
  [ManagementLevel.Freelancer]: 'other',
  [ManagementLevel.StudentIntern]: 'other',
  [ManagementLevel.Other]: 'other'
};